export const FILTER_SETTINGS = {
  PAGE_SIZE: 10,
  OFFSET: 0,
  LIMIT: 10,
};

export const FILTER_COLORS = {
  BACKGROUND: "#b4b4b4",
  LOADING_INDICATOR: "#666",
};

export const CASE_STATUS = {
  DRAFT: "draft",
  APPROVED: "approved",
  DELETED: "deleted",
  SUBMITTED: "submitted",
  REJECTED: "rejected",
  "APPROVAL-EDITED": "approvalEdited",
};

export const FILTER_DATES = {
  FROM: "from",
  TO: "to",
};

export const QUERY_PARAMS = {
  PAGE: "page",
  SORT_BY: "sortBy",
  ORDER_BY: "orderBy",
  FILTERS: "filters",
  ASC: "asc",
  DESC: "desc",
  BY_ID: "id",
  INITIAL_PAGE: "1",
  SEARCH_QUERY: "searchQuery",
  SHOW_ONLY_MY_CASES: "showOnlyMyCases",
};

export const USADMIN_ENTITIES = {
  VENDORS: "vendors",
  END_USERS: "end-users",
  DISTRIBUTORS: "distributors",
  TERRITORY_MANAGERS: "territory-managers",
  INDUSTRY_SPECIALISTS: "industry-specialists",
};

export const HEADER_LINKS = {
    INCIDENT_REPORT_URL: "https://skf.com/websupport",
    REQUEST_FOR_CHANGE_URL: "https://skf.com/websupport",
}

export const US_ADMIN_APP = "US ADMIN APP";
export const MAIN_FILTER_STATUS_KEY = "status";
export const STATUS_TRANSLATION_KEY = "preview";
export const DEFAULT_LANGUAGE = "English"
export const REPORT_NEEDS_APPROVAL_PATTERN = /bearingInvestigations\.bearingInvestigation\[(\d+)\]\.recommendations\.reportNeedsApproval/;
